import React, { useEffect } from "react"
import { graphql } from "gatsby"
import { Schema } from "../schema"
import parse from "html-react-parser"

import { useHomeNewMetadata } from "../queries/useHomeNewMetaData"
import { replaceUnderscoresWithSpaces } from "../utils/functions"
import Seo from "../components/seo"
import Guide from "../components/newComponents/guide/guide"
import Header from "../components/header/header"
import Faq from "../components/newComponents/faq/faq"
import Overview from "../components/newComponents/overView/overview"
import Blog from "../components/newComponents/blog/blog"
import WhyService from "../components/newComponents/whyService/whyService"
import MainBanner from "../components/newComponents/mainBanner/mainBanner"
import Footer from "../components/newComponents/footer/footer"
import WhyAgile from "../components/newComponents/whyAgile/whyAgile"
import Hiredeveloper from "../components/newComponents/hireDeveloper/hiredeveloper"
import CaseStudies from "../components/newComponents/caseStudies/caseStudies"
import Testimonials from "../components/newComponents/testimonials/testimonials"
import BusinessForm from "../components/newComponents/businessForm/businessForm"
import HealthCareWhatWeDo from "../components/newComponents/healthCareWhatWeDo/healthCareWhatWeDo"
import CliensPartners from "../components/newComponents/cliensPartners/cliensPartners"
import OurAlliance from "../components/newComponents/ourAlliance/ourAlliance"
import Cta from "../components/newComponents/CTA/cta"
import DevelopmentProcess from "../components/newComponents/developmentProcess/developmentProcess"
import Benefits from "../components/newComponents/benefits/benefits"

const WhatwedoCapabilitiesServices = ({ data }) => {
  const homeData = useHomeNewMetadata()

  const {
    homeCaseContent,
    homeCaseTitle,
    homeCaseSubTitle,

    homeWhyContent,
    homeWhyTitle,
    homeWhyShowSection,
    homeWhySubTitle,
    homeWhyAgileContect,
    homeNewWhyIconTextList,
    homeWhyVideoUrl,

    homeTestimonialsContent,
    homeTestimonialsTitle,
    homeTestimonialsSubTitle,
    homeTestimonialsViewAllLink,
    homeBlogViewAllLink,

    homeBlogContent,
    homeBlogTitle,
    homeBlogSubTitle,

    homeWorkContent,
    homeWorkShowSection,
    homeWorkSubTitle,
    homeWorkTitle,
    homeNewWorkLogoList,

    faqSmallContent,
    faqButtonText,
    faqButtonLink,

    homeAllianceSection,
    homeNewAllianceImageList,
    homeAllianceTitle,
    homeAllianceContent,
    homeAllianceSubTitle,
  } = homeData?.wpPage?.homePageNewFields

  // services data
  const {
    selectCaseStudies,
    selectTestimonials,
    selectBlogs,
    serviceListOfUserGuides,
    userGuideShowSection,

    capBannerButtonText,
    capBannerSubTitle,
    capBannerContents,
    capBannerShowSection,
    capBannerButtonLink,
    capBannerBackgroundImage,
    capBannerTitle,

    capOverviewTitle,
    overviewImage,
    capOverviewContent,
    capOverviewSubTitle,
    capOverviewShowSection,

    servContent,
    servShowSection,
    servSubTitle,
    servTitle,
    servicesCapImageContentList,
    capCaseStudiesShowSection,
    capBlogsShowSection,
    capTestimonialsShowSection,
    userGuideMainTitle,
    userGuideContent,
    userGuideSubTitle,

    capHireBoxButtonLink,
    capHireBoxIcon,
    capHireBoxTitle,
    capHireShowSection,
    capHireTitle,
    capHireSubTitle,
    capHireBoxButtonText,
    capIntroBoxContent,
    capIntroContent,
    // capHireIntroContent, // Todo Add to dynamic query

    // capHireBoxTitle,
    // capHireBoxContent,
    // capHireBoxButtonLink,
    capHireListOfTechnology,

    capWhyContent,
    capWhyShowSection,
    capWhySubTitle,
    capWhyTitle,
    capWhyIconTextLists,

    capFaqSchema,
    viewsCountShowSection,
    viewsCount,
    cta1ShowSection,
    cta1Title,
    cta1Tag,
    cta1Cta,

    developmentContent,
    developmentTitle,
    developmentSubtitle,
    developmentProcessList,
    developmentProcessShowSection,

    
    capFaqTitle,
    capFaqContent,
    capFaqSubTitle,
    capFaqShowSection,
    capFaqQuestionAnswerLists,
  } = data?.wpPage?.CapabilitiesNewPageFields
  
  const { seo } = homeData?.wpPage

  useEffect(() => {
    localStorage.removeItem("casepage")
    localStorage.removeItem("blogpage")
  }, [])

  const schema = Schema
  let customSchema = parse(`${data?.wpPage?.MetaFields?.customPageSchema}`)
  let faqSchema = capFaqSchema ? parse(`${capFaqSchema}`) : ""



  return (
    <>
      <Seo
        title={seo?.title}
        seoData={data?.wpPage?.MetaFields}
        schemaMarkup={schema}
        customPageSchema={customSchema}
        faqSchema={faqSchema}
        bannerImage={capBannerBackgroundImage?.mediaItemUrl}
      />

      <Header homeData={homeData?.wp} />

      <MainBanner
        homeBannerTitle={capBannerTitle}
        homeBannerSubTitle={capBannerSubTitle}
        homeBannerContent={capBannerContents}
        homeBannerButtonText={capBannerButtonText}
        homeBannerButtonLink={capBannerButtonLink}
        homeBannerShowSection={capBannerShowSection}
        homeBannerBackgroundImage={capBannerBackgroundImage}
      />

      <Overview
        overviewTag={capOverviewTitle}
        overviewContent={capOverviewContent}
        overviewShowSection={capOverviewShowSection}
        overviewTitle={capOverviewSubTitle}
        overviewImage={overviewImage}
        />

      <WhyService
        capWhyContent={capWhyContent}
        capWhyShowSection={capWhyShowSection}
        capWhySubTitle={capWhySubTitle}
        capWhyTitle={replaceUnderscoresWithSpaces(capWhyTitle)}
        capWhyIconTextList={capWhyIconTextLists}
        />

      <HealthCareWhatWeDo
        serviceTitle={servSubTitle}
        serviceTag={servTitle}
        serviceShowSection={servShowSection}
        serviceShortDescription={servContent}
        serviceImageContentList={servicesCapImageContentList}
        healthcarePage="yes"
        isCollapse="no"
        />

      <Hiredeveloper
        capHireShowSection={capHireShowSection}
        capHireSubTitle={capHireSubTitle}
        capHireTitle={replaceUnderscoresWithSpaces(capHireTitle)}
        capIntroContent={capIntroContent}
        capHireBoxIcon={capHireBoxIcon}
        capHireBoxTitle={capHireBoxTitle}
        capHireBoxButtonText={capHireBoxButtonText}
        capHireBoxButtonLink={capHireBoxButtonLink}
        capHireBoxContent={capIntroBoxContent}
        capHireListOfTechnology={capHireListOfTechnology}
        />

      
      <Cta
        cta1Tag={cta1Tag}
        cta1Title={cta1Title}
        cta1Cta={cta1Cta}
        cta1ShowSection={cta1ShowSection}
      />

      <DevelopmentProcess
        title={developmentTitle}
        subTitle={developmentSubtitle}
        content={developmentContent}
        developmentProcessList={developmentProcessList}
        developmentProcessShowSection={developmentProcessShowSection}
      />

      <Benefits
        benefitsShowSection={"no"}
        benefitsContent={
          "We begin with a comprehensive discovery phase, understanding your business requirements, goals, and target audience. This helps us create a detailed project roadmap,"
        }
        benefitsTag={"Benefits"}
        benefitsTitle={"How We Do It?"}
      />

      <CaseStudies
        homeCaseContent={homeCaseContent}
        homeCaseTitle={homeCaseTitle}
        homeCaseSubTitle={homeCaseSubTitle}
        homeCaseShowSection={capCaseStudiesShowSection}
        selectCaseStudies={selectCaseStudies}
        CustomClass="casestudies-section"
      />

      <WhyAgile
        homeWhyContent={homeWhyContent}
        homeWhyTitle={homeWhyTitle}
        homeWhyShowSection={homeWhyShowSection}
        homeWhySubTitle={homeWhySubTitle}
        homeWhyIconTextList={homeNewWhyIconTextList}
        homeWhyAgileContect={homeWhyAgileContect}
        homeWhyVideoUrl={homeWhyVideoUrl}
      />

      <Testimonials
        homeTestimonialsContent={homeTestimonialsContent}
        homeTestimonialsTitle={homeTestimonialsTitle}
        homeTestimonialsShowSection={capTestimonialsShowSection}
        homeTestimonialsSubTitle={homeTestimonialsSubTitle}
        testimonialList={selectTestimonials}
        homeTestimonialsViewAllLink={homeTestimonialsViewAllLink}
      />

      <Guide
        userGuideContent={userGuideContent}
        userGuideTitle={userGuideMainTitle}
        serviceListOfUserGuide={serviceListOfUserGuides}
        userGuideShowSection={userGuideShowSection}
        userGuideSubTitle={userGuideSubTitle}
      />

      <Blog
        homeBlogContent={homeBlogContent}
        homeBlogTitle={homeBlogTitle}
        selectBlog={selectBlogs}
        homeBlogShowSection={capBlogsShowSection}
        homeBlogSubTitle={homeBlogSubTitle}
        homeBlogViewAllLink={homeBlogViewAllLink}
        viewsCountShowSection={viewsCountShowSection}
        viewsCount={viewsCount}
      />

      <CliensPartners
        homeWorkContent={homeWorkContent}
        homeWorkLogoList={homeNewWorkLogoList}
        homeWorkShowSection={homeWorkShowSection}
        homeWorkSubTitle={homeWorkSubTitle}
        homeWorkTitle={homeWorkTitle}
        CustomClass={'section_initial_padding'}
      />
      
      <Faq
        faqTitle={capFaqTitle}
        faqContent={capFaqContent}
        faqSubTitle={capFaqSubTitle}
        faqButtonText={faqButtonText}
        faqButtonLink={faqButtonLink}
        faqSmallContent={faqSmallContent}
        faqShowSection={capFaqShowSection}
        faqQuestionAnswerList={capFaqQuestionAnswerLists}
      />

      
      <BusinessForm homeData={homeData?.wp} CustomClass="pt-110" />

      <OurAlliance
        homeAllianceSection={homeAllianceSection}
        homeAllianceImageList={homeNewAllianceImageList}
        homeAllianceTitle={homeAllianceTitle}
        homeAllianceContent={homeAllianceContent}
        homeAllianceSubTitle={homeAllianceSubTitle}
      />

      <Footer
        footerMenu={homeData?.wpMenu?.menuItems}
        homeData={homeData?.wp?.myThemeOptionsSettings}
      />
    </>
  )
}

export default WhatwedoCapabilitiesServices

export const query = graphql`
  query ServicesData($slug: String) {
    wpPage(slug: { eq: $slug }) {
      slug
      title
      id
      uri
      CapabilitiesNewPageFields {
        capBannerTitle
        capBannerSubTitle
        capBannerContents
        capBannerButtonText
        capBannerShowSection

        capHireBoxButtonLink {
          target
          title
          url
        }
        capHireBoxButtonText
        capHireBoxIcon
        capHireBoxTitle
        capHireShowSection
        capHireSubTitle
        capHireTitle
        capIntroBoxContent
        capIntroContent

        capBannerButtonLink {
          target
          title
          url
        }
        capBannerBackgroundImage {
          mediaItemUrl
          altText
        }
        capOverviewTitle
        capOverviewContent
        capOverviewSubTitle
        capOverviewShowSection
        overviewImage {
          mediaItemUrl
          altText
        }

        developmentProcessShowSection
        developmentContent
        developmentTitle
        developmentSubtitle
        developmentProcessList {
          developmentProcessContent
          developmentProcessIcon
          developmentProcessTitle
        }
        capHireListOfTechnology {
        	capHireListTechnology
      	}
        capWhyTitle
        capWhySubTitle
        capWhyContent
        capWhyShowSection
        capWhyCenterImage {
          mediaItemUrl
          altText
        }
        capWhyIconTextLists {
          tabListTitle
          capWhyListIcon
          capWhyListText
          capWhyListDescription
          fieldGroupName
        }

        servTitle
        servContent
        servSubTitle
        servShowSection
        servicesCapImageContentList {
          fieldGroupName
          serviceListContent
          serviceListImage
          serviceListTitle
        }

        engageTitle
        engageContent
        engageSection
        engageSubTitle
        capEngageIconContentList {
          engageListContent
          engageListIcon
          engageListLinkText
          engageListText
          fieldGroupName
          engageListLinkUrl {
            target
            title
            url
          }
        }

        cta1ShowSection
        cta1Title
        cta1Tag
        cta1Cta {
          title
          url
        }

        capHireTitle
        capFaqSchema
        capHireSubTitle
        capHireShowSection

        capFaqTitle
        capFaqSubTitle
        capFaqContent
        capFaqShowSection
        capFaqQuestionAnswerLists {
          faqListAnswer
          faqListQuestion
        }
        fieldGroupName

        userGuideContent
        userGuideMainTitle
        userGuideSubTitle
        userGuideShowSection
        userGuideTabRoleText
        serviceListOfUserGuides {
          fieldGroupName
          userGuideTabContent
          userGuideTabTitle
          userGuideTabListing {
            fieldGroupName
            userGuideTabMainText
            userGuideTabSubText
          }
        }

        capBlogsShowSection
        selectBlogs {
          ... on WpPost {
            id
            categories {
              nodes {
                name
              }
            }
            singlePageFieldsNew {
              viewsCountShowSection
              viewsCount
              authorDesignation
              authorName
              showAuthor
              authorImage {
                mediaItemUrl
                altText
              }
            }
            featuredImage {
              node {
                mediaItemUrl
                altText
              }
            }
            date
            content
            title
            slug
          }
        }
        capCaseStudiesShowSection
        selectCaseStudies {
          ... on WpCaseStudy {
            id
            title
            slug
            featuredImage {
              node {
                mediaItemUrl
                altText
              }
            }
            content
            CaseStudiesPostFieldsNew {
              caseIndustryTag
              caseSolutionTag
              caseSolution
              caseIndustry
              caseTitle
              caseSubTitle
              caseCountry
              portfolioDarkColorCode
              portfolioLightColorCode
              portfolioTextColorCode
              portfolioParentClassName
            }
          }
        }

        capTestimonialsShowSection
        selectTestimonials {
          ... on WpTestimonial {
            id
            title
            slug
            content
            featuredImage {
              node {
                mediaItemUrl
                altText
              }
            }
            TestimonialsField {
              country
              feedback
              position
              videoLink {
                altText
                mediaItemUrl
              }
              pageLink
            }
          }
        }
      }
      MetaFields {
        customPageSchema
        customSeoFocusKeyphrase
        customSeoKeywords
        customSeoMetaDescription
        customSeoMetaTitle
        customSeoRobotFollow
        customSeoRobotIndex
        fieldGroupName
        customSeoOgUrl
        customPageSchema
      }
    }
  }
`
